import React, { useEffect, useState } from 'react';

import { Tabs, TabList, TabPanel } from 'react-tabs';
import { useNavigate } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import Sale01 from '../components/sale/Sale01';
import { getCurrency } from "../redux/currency/currencyActions";
import { addTransaction } from "../redux/transaction/transactionActions";
import { getAllAdjustments } from "../redux/adjustment/adjustmentActions";
import { getWalletAddressByCurrencyId } from "../redux/wallet/walletActions";
import { useDispatch, useSelector } from "react-redux";
import CustomDropdown from '../components/dropdown/CustomDropdown';
import { useTranslation } from 'react-i18next';
import { apiHelper } from "../redux/apiHelper";

function BuyCrypto() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [giveToken, setGiveToken] = useState(null);
    const [reciveToken, setReciveToken] = useState(null);
    const [fromCurrency, setFromCurrency] = useState("");
    const [toCurrency, setToCurrency] = useState("");
    const [exchangeRate, setExchangeRate] = useState("");
    const [fromAmount, setFromAmount] = useState("");
    const [toAmount, setToAmount] = useState("");
    const [valueEmailInput, setValueEmailInput] = useState("");
    const [valueAddressInput, setvalueAddressInput] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);

    const currencies = useSelector((state) => state.currency?.currencies);
    const adjustmentData = useSelector((state) => state.adjustment?.adjustment);
    const walletAddress = useSelector((state) => state.walletAddress?.addressByCurrency);

    const [dataCryptoTab] = useState([
        {
            id: 'dataCryptoTab1',
        },
        {
            id: 'dataCryptoTab2',
        },
        {
            id: 'dataCryptoTab3',
        },
    ])

const applyPercentageAdjustment = (fromCurrency, toCurrency, amount) => {
    if (!adjustmentData || !Array.isArray(adjustmentData) || adjustmentData.length === 0) {
        return amount;
    }

    // Guard against null/undefined fromCurrency / toCurrency on the adjustment objects
    const adjustment = adjustmentData.find(adj =>
        adj?.fromCurrency?.symbol === fromCurrency &&
        adj?.toCurrency?.symbol === toCurrency
    );

    if (adjustment) {
        return amount * (1 + Number(adjustment.adjustment || 0) / 100);
    }

    return amount;
};

    const handleFromChange = (event) => {
        const amount = event.target.value;
        setFromAmount(amount);
        if (!fromCurrency || !toCurrency || !exchangeRate) {
        setToAmount("");
        return;
    }
        const adjustedAmount = applyPercentageAdjustment(
            fromCurrency,
            toCurrency,
            amount * exchangeRate
        );
        setToAmount(Number(adjustedAmount));
    };

    const handleToChange = (event) => {
        const amount = event.target.value;
        setToAmount(amount);
        if (!fromCurrency || !toCurrency || !exchangeRate) {
        setToAmount("");
        return;
    }
        const adjustedAmount = applyPercentageAdjustment(
            toCurrency,
            fromCurrency,
            amount / exchangeRate
        );
        setFromAmount(Number(adjustedAmount));
    };

    const resetForm = () => {
        setFromCurrency("");
        setToCurrency("");
        setExchangeRate("");
        setFromAmount("");
        setToAmount("");
        setValueEmailInput("");
        setvalueAddressInput("");
    };

    const handleChangeInput = (event, adress) => {
        const { value } = event.target;
        adress ? setvalueAddressInput(value) : setValueEmailInput(value);
    };

    // Fetches { rate, fromUsd, toUsd } from our own backend, which in turn
    // talks to CoinGecko using each currency's coinGeckoId. Never call a
    // pricing provider directly from the browser.
    const fetchExchangeRateData = async (fromId, toId) => {
        try {
            const response = await apiHelper(
                "get",
                `/api/currency/rate/${fromId}/${toId}`,
                ""
            );
            return response?.data;
        } catch (err) {
            console.error(`Failed to fetch exchange rate. ${err.message}`);
            return null;
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const rateData = await fetchExchangeRateData(giveToken._id, reciveToken._id);

        if (!rateData) {
            setErrorMessage("Could not fetch current exchange rates. Please try again.");
            return;
        }

        const fromAmountInUSD = fromAmount * rateData.fromUsd;
        const convertedAmountInUSD = toAmount * rateData.toUsd;

        if (fromAmountInUSD < 50 || convertedAmountInUSD < 50) {
            setErrorMessage("Minimum transaction amount should be equivalent to $50.");
            return;
        } else if (!valueEmailInput || !valueAddressInput || !fromAmount || !toAmount || fromAmount <= 0 || toAmount <= 0) {
            setErrorMessage('Please fill out all necessary fields with valid amounts.');
            return;
        } else if (!termsAccepted) {
            setErrorMessage('Please accept the Terms of Service.');
            return;
        } else {
            setErrorMessage(""); // Reset error message if there is any
        }

        const data = {
            userId: localStorage.getItem("userId"),
            email: valueEmailInput,
            address: valueAddressInput,
            fromCurrency: giveToken._id,
            toCurrency: reciveToken._id,
            fromAmount,
            convertedAmount: toAmount,
            // userIP,
        };

        try {
            const transactionId = await dispatch(addTransaction(data));
            resetForm();
            // onSubmit(transactionId); // pass transactionId to onSubmit
            console.log(transactionId)
            navigate(`/buy-crypto-confirm/${transactionId}`)
        } catch (error) {
            console.error("Transaction could not be submitted", error);
        }
    };

    const handleSwitchCurrency = () => {
        setFromCurrency(toCurrency);
        setToCurrency(fromCurrency);

        // Switch giveToken and reciveToken as well.
        const tempGiveToken = giveToken;
        setGiveToken(reciveToken);
        setReciveToken(tempGiveToken);
    };


    useEffect(() => {
        dispatch(getCurrency());
        dispatch(getAllAdjustments());
    }, [dispatch]);

    useEffect(() => {
        if (currencies.length) {
            // Sort currencies alphabetically
            const sortedCurrencies = [...currencies].sort((a, b) =>
                a.symbol.localeCompare(b.symbol));

            // Find KRW and USDT from the sorted list, if they exist.
            const krwCurrency = sortedCurrencies.find(currency => currency.symbol === 'KRW') || sortedCurrencies[0];
            const usdtCurrency = sortedCurrencies.find(currency => currency.symbol === 'USDT') || sortedCurrencies[1];

            setGiveToken(krwCurrency);
            setReciveToken(usdtCurrency);
            setFromCurrency(krwCurrency.symbol);
            setToCurrency(usdtCurrency.symbol);
        }
    }, [currencies]);

    useEffect(() => {
        if (reciveToken && reciveToken._id) {
            dispatch(getWalletAddressByCurrencyId(reciveToken._id));
        }
    }, [dispatch, reciveToken]);


    useEffect(() => {
        if (giveToken?._id && reciveToken?._id) {
            fetchExchangeRateData(giveToken._id, reciveToken._id).then((rateData) => {
                if (rateData?.rate) {
                    setExchangeRate(rateData.rate);
                }
            });
        }
    }, [giveToken, reciveToken]);

useEffect(() => {
    if (fromAmount && exchangeRate && fromCurrency && toCurrency) {
        const adjustedAmount = applyPercentageAdjustment(
            fromCurrency,
            toCurrency,
            fromAmount * exchangeRate
        );
        setToAmount(Number(adjustedAmount));
    }
}, [exchangeRate, fromAmount, fromCurrency, toCurrency]);

    return (
        <div>
            <section className="buy-crypto flat-tabs">
                <div className="container">
                    <div className="row">
                        <Tabs>
                            <TabList>

                                {
                                    dataCryptoTab.map(idx => (
                                        <span className={`react-tabs__tab${idx.id === 'dataCryptoTab1' ? ' react-tabs__tab--selected' : ''}`} key={idx.id}>{t(`dataCryptoTab.${idx.id}.title`)}</span>
                                    ))
                                }

                            </TabList>

                            <TabPanel>
                                <div className="content-inner buy-crypto__main">
                                    <div className="top">
                                        <ul className="top-list">
                                            <li className="active">
                                                <h6><span></span>{t('selectCurrency')}</h6>
                                            </li>
                                            <li>
                                                <h6><span></span>{t('confirmPayment')}</h6>
                                            </li>
                                            <li>
                                                <h6><span></span>{t('invoice')}</h6>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="main">
                                        <h6>{t('submitExchange')}</h6>
                                        {/* <p>Reference Price: 1,450,939,280.43 VND/BTC</p> */}

                                        <form action="/buy-crypto-confirm" className="form" onSubmit={handleSubmit}>
                                            <div className="form-field">
                                                <label>{t('pay')}</label>
                                                <CustomDropdown
                                                    currencies={currencies}
                                                    selectedCurrency={fromCurrency}
                                                    onCurrencyChange={(fromCurrency) => {
                                                        setFromCurrency(fromCurrency);
                                                        setGiveToken(currencies.find((currency) => currency.symbol === fromCurrency));
                                                    }}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <label>{t('receive')}</label>
                                                <CustomDropdown
                                                    currencies={currencies}
                                                    selectedCurrency={toCurrency}
                                                    onCurrencyChange={(toCurrency) => {
                                                        setToCurrency(toCurrency);
                                                        setReciveToken(currencies.find((currency) => currency.symbol === toCurrency));
                                                    }}
                                                />
                                            </div>

                                            <div className="form-field">
                                                <label>{t('amountToSend')}</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="any"
                                                    className="dollar"
                                                    placeholder={giveToken?.name}
                                                    value={fromAmount}
                                                    onChange={handleFromChange}
                                                />
                                            </div>
                                            <button className="btn-convert" onClick={handleSwitchCurrency}>
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M17.6691 3.02447L15.4471 0.35791C15.3074 0.195998 15.1203 0.106407 14.9261 0.108432C14.7319 0.110457 14.5461 0.203937 14.4088 0.368737C14.2715 0.533538 14.1936 0.756473 14.1919 0.989527C14.1902 1.22258 14.2649 1.44711 14.3998 1.61475L15.3575 2.76403H2.3319C1.74258 2.76403 1.1774 3.04497 0.760683 3.54505C0.34397 4.04512 0.109863 4.72337 0.109863 5.43059L0.109863 8.09714C0.109863 8.33288 0.187899 8.55896 0.326803 8.72566C0.465707 8.89235 0.654102 8.986 0.850542 8.986C1.04698 8.986 1.23538 8.89235 1.37428 8.72566C1.51319 8.55896 1.59122 8.33288 1.59122 8.09714V5.43059C1.59122 5.19485 1.66926 4.96877 1.80816 4.80207C1.94707 4.63538 2.13546 4.54174 2.3319 4.54174H15.3575L14.3998 5.69102C14.329 5.77302 14.2726 5.8711 14.2338 5.97954C14.195 6.08798 14.1745 6.20462 14.1737 6.32264C14.1728 6.44066 14.1916 6.5577 14.2288 6.66694C14.2661 6.77618 14.3211 6.87542 14.3906 6.95888C14.4601 7.04233 14.5428 7.10833 14.6339 7.15302C14.7249 7.19772 14.8224 7.22021 14.9208 7.21918C15.0191 7.21816 15.1163 7.19363 15.2067 7.14705C15.297 7.10047 15.3788 7.03275 15.4471 6.94786L17.6691 4.2813C17.8052 4.11283 17.8812 3.88746 17.8812 3.65288C17.8812 3.41831 17.8052 3.19293 17.6691 3.02447Z"
                                                        fill="white"
                                                    />
                                                    <path
                                                        d="M17.1467 8.98828C16.9503 8.98828 16.7619 9.08193 16.623 9.24862C16.4841 9.41531 16.406 9.64139 16.406 9.87713V12.5437C16.406 12.7794 16.328 13.0055 16.1891 13.1722C16.0502 13.3389 15.8618 13.4325 15.6653 13.4325H2.63976L3.59746 12.2832C3.73238 12.1156 3.80704 11.8911 3.80535 11.658C3.80366 11.425 3.72576 11.202 3.58844 11.0372C3.45111 10.8724 3.26534 10.779 3.07113 10.7769C2.87693 10.7749 2.68983 10.8645 2.55014 11.0264L0.328098 13.693C0.191902 13.8613 0.115723 14.0867 0.115723 14.3214C0.115723 14.556 0.191902 14.7814 0.328098 14.9498L2.55014 17.6164C2.61846 17.7012 2.70019 17.769 2.79056 17.8155C2.88092 17.8621 2.97812 17.8866 3.07646 17.8877C3.17481 17.8887 3.27234 17.8662 3.36337 17.8215C3.4544 17.7768 3.53709 17.7108 3.60664 17.6274C3.67618 17.5439 3.73118 17.4447 3.76842 17.3354C3.80567 17.2262 3.82441 17.1092 3.82355 16.9911C3.8227 16.8731 3.80226 16.7565 3.76345 16.648C3.72463 16.5396 3.6682 16.4415 3.59746 16.3595L2.63976 15.2102H15.6653C16.2547 15.2102 16.8199 14.9293 17.2366 14.4292C17.6533 13.9291 17.8874 13.2509 17.8874 12.5437V9.87713C17.8874 9.64139 17.8094 9.41531 17.6704 9.24862C17.5315 9.08193 17.3431 8.98828 17.1467 8.98828Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </button>
                                            <div className="form-field">
                                                <label>{t('amountToReceive')}</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="any"
                                                    className="bitcoin"
                                                    placeholder={reciveToken?.name}
                                                    value={toAmount}
                                                    onChange={handleToChange}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <label>{t('email')}</label>
                                                <input
                                                    type="email"
                                                    className="dollar"
                                                    placeholder="Email"
                                                    value={valueEmailInput}
                                                    onChange={(e) => handleChangeInput(e, false)}
                                                />
                                            </div>
                                            <div className="form-field">
                                                <label>{t('address')} {walletAddress ? walletAddress?.name : ''} {t('network')}</label>
                                                <input
                                                    type="text"
                                                    className="address"
                                                    placeholder="0x"
                                                    value={valueAddressInput}
                                                    onChange={(e) => handleChangeInput(e, true)}
                                                />
                                            </div>
                                            {errorMessage ? (
                                                <div
                                                    style={{ color: "#FE6E00", marginTop: "15px" }}
                                                    className="alert alert-danger">
                                                    {" "}
                                                    {errorMessage}{" "}
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            <div style={{ marginBottom: "8px", display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    id="terms"
                                                    name="terms"
                                                    value={termsAccepted}
                                                    onChange={() => setTermsAccepted(!termsAccepted)}
                                                />
                                                <label style={{ marginLeft: "5px" }} htmlFor="terms">{t('termsAccept')}<a href="/regulations" target="_blank" rel="noopener noreferrer">{t('termsOfService')}</a></label>
                                            </div>
                                            <button type="submit" className="btn-action">{t('continue1')}</button>
                                        </form>

                                        <div className="button"></div>
                                    </div>
                                </div>
                            </TabPanel>

                        </Tabs>

                    </div>
                </div>
            </section>

            <Sale01 />

        </div>
    );
}

export default BuyCrypto;